import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function ClosingSection() {
  return <section className="bg-bbq-surface py-24 px-4 border-t border-white/5" data-id="element-1">
      <div className="max-w-4xl mx-auto text-center" data-id="element-2">
        <h2 className="text-3xl md:text-5xl font-display font-bold text-white uppercase tracking-wide mb-12" data-id="element-3">
          Tienes dos caminos ahora mismo:
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16" data-id="element-4">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-bbq-dark p-8 rounded-xl border border-white/5 opacity-70" data-id="element-5">
            <h3 className="text-xl font-display font-bold text-gray-400 uppercase mb-4" data-id="element-6">
              Camino A
            </h3>
            <p className="text-gray-500" data-id="element-7">
              Regalarle a papá lo mismo de siempre (calcetines, una taza, una
              corbata) y seguir comiendo carne dura los domingos.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-gradient-to-b from-bbq-ember/20 to-bbq-dark p-8 rounded-xl border border-bbq-ember/50 relative" data-id="element-8">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-bbq-ember text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-9">
              Recomendado
            </div>
            <h3 className="text-xl font-display font-bold text-white uppercase mb-4" data-id="element-10">
              Camino B
            </h3>
            <p className="text-gray-200" data-id="element-11">
              Darle el regalo que le apasiona, ahorrar dinero en futuras compras
              de carne y convertir cada almuerzo familiar en un banquete
              inolvidable.
            </p>
          </motion.div>
        </div>

        <motion.button onClick={() => {
        window.location.href = 'https://www.merlanis.com/cart/53892945052016:1';
      }} whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} className="w-full md:w-auto bg-bbq-ember hover:bg-bbq-ember-dark text-white font-display text-xl md:text-2xl uppercase tracking-wider py-6 px-8 md:px-16 rounded-md transition-all duration-300 shadow-[0_0_40px_rgba(232,98,45,0.3)] hover:shadow-[0_0_60px_rgba(232,98,45,0.5)] flex flex-col items-center justify-center gap-2 mx-auto" data-id="element-12">
          <span className="flex items-center gap-3" data-id="element-13">
            SÍ, QUIERO QUE PAPÁ SEA UN MAESTRO PARRILLERO
            <ArrowRight size={24} data-id="element-14" />
          </span>
          <span className="text-sm md:text-base text-white/80 tracking-normal normal-case font-sans" data-id="element-15">
            Acceso Inmediato por $6.390
          </span>
        </motion.button>
      </div>
    </section>;
}